import apiClient from 'services/axios'

const BASE_URL = 'blog'

export async function loadAll(payload) {
  return apiClient
    .get(`${BASE_URL}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function create(payload) {
  return apiClient
    .post(`${BASE_URL}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function update(blogId, payload) {
  return apiClient
    .put(`${BASE_URL}/${blogId}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function remove(blogId, payload) {
  return apiClient
    .delete(`${BASE_URL}/${blogId}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}
